import { Component } from 'react';
import { connect } from 'react-redux';
import { setQuestionLevels } from '../../redux/reducers/questionLevelsReducer';
import { getAllQuesModules } from '../../services/apiService';

import AddNewQuestion from './tabs/AddOrEditQuestion';
import AllQuestions from './tabs/AllQuestions';
import Archive from './tabs/Archive';
import LevelBuilder from './tabs/LevelBuilder';
import UploadCSV from './tabs/UploadCSV';

const activeClass = 'bg-white text-green-c1 font-semibold px-6 py-3';
const inactiveClass = 'bg-gray-300 cursor-pointer px-6 py-3';

const TAB = {
  ALL_QUES: 'All Questions',
  ADD_NEW_QUES: 'Add New Question',
  UPLOAD_CSV: 'Upload CSV',
  ARCHIVE: 'Archive',
  LEVEL_BUILDER: 'Level Builder',
};

class QuestionBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: TAB.ALL_QUES,
    };
  }

  componentDidMount = async () => {
    try {
      if (!this.props.modules.length)
        this.props.dispatch(setQuestionLevels(await getAllQuesModules()));
    } catch (err) {
      console.error(err);
    }
  };

  changetab = (tabView) => {
    this.setState({ selectedTab: tabView });
  };

  renderSelectedTab = () => {
    switch (this.state.selectedTab) {
      case TAB.ALL_QUES:
        return <AllQuestions />;

      case TAB.ADD_NEW_QUES:
        return <AddNewQuestion />;

      case TAB.UPLOAD_CSV:
        return <UploadCSV changeTab={() => this.changeTab(TAB.ALL_QUES)} />;

      case TAB.ARCHIVE:
        return <Archive />;

      case TAB.LEVEL_BUILDER:
        return <LevelBuilder />;

      default:
        return <div>Coming Soon</div>;
    }
  };

  render() {
    return (
      <div>
        <h1 className='user-heading text-3xl font-semibold my-5'>
          Question Builder
        </h1>
        <div className='flex gap-2'>
          {Object.keys(TAB).map((tab) => (
            <div
              onClick={() => this.setState({ selectedTab: TAB[tab] })}
              key={tab}
              className={
                this.state.selectedTab === TAB[tab]
                  ? activeClass
                  : inactiveClass
              }
            >
              {TAB[tab]}
            </div>
          ))}
        </div>

        {this.renderSelectedTab()}
      </div>
    );
  }
}

const mapStateToProps = ({ questionLevelsReducer }) => ({
  modules: questionLevelsReducer.modules,
  competencies: questionLevelsReducer.competencies,
  concepts: questionLevelsReducer.concepts,
});

export default connect(mapStateToProps)(QuestionBuilder);
